"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = tape_sanitizer_1.PyXlsxVirtualSheet2CsvTransformationSchema.omit({
    srcDataTape: true,
}).extend({
    operation: zod_1.z.literal('pyXlsxVirtualSheet2Csv'),
    srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
});
exports.UIConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
});
exports.nodeType = 'operation_pyXlsxVirtualSheet2Csv';
//# sourceMappingURL=types.js.map